import styled from 'styled-components';
import {BGImageCenter, dFlex, ellipsis, mobileMedia} from '../../../../globalVariables/GlobalVariables';
import {tokens} from '@tickchak/react-share/app';
import {whatsApp} from '../../../../assets/symbols/symbols/Symbols.css';

const AVATAR_SIZE = 66;
const COVER_HEIGHT = 125;

export const card = styled.div`
    width: 100%;
    height: 263px;
    max-width: 216px;
    border: 1px solid ${tokens.color.border.subtle};
    border-radius: var(--radius-md);
    background: ${tokens.color.bg.base};
    overflow: hidden;
    box-sizing: border-box;
    touch-action: manipulation;
    ${mobileMedia}{ max-width: none; height: auto; }
`;

export const cover = styled.div`
    height: ${COVER_HEIGHT}px;
    padding: var(--space-sm);
    box-sizing: border-box;
    border-bottom: 1px solid ${tokens.color.border.subtle};
    ${mobileMedia}{ height: 86px; }
`;

export const topBar = styled.div`
    ${dFlex};
    align-items: center;
    gap: var(--space-sm);
    width: 100%;
`;

export const topBarSide = styled.div`
    ${dFlex};
    align-items: center;
    gap: var(--space-xs);
    margin-inline-start: auto;
`;

export const badge = styled.div<{ $bg?: string }>`
    ${dFlex};
    align-items: center;
    gap: var(--space-xs);
    padding: var(--space-xs);
    border-radius: var(--radius-xs);
    background: ${p => p.$bg || tokens.color.brand.subtle};
    font-size: ${tokens.typography.fontSize.caption};
    font-weight: ${tokens.typography.fontWeight.regular};
    line-height: 16px;
    color: ${tokens.color.text.default};
    white-space: nowrap;
`;

export const avatar = styled.div<{ $image?: string }>`
    margin: calc(${AVATAR_SIZE}px / -2) auto 0;
    width: ${AVATAR_SIZE}px;
    height: ${AVATAR_SIZE}px;
    border-radius: 50%;
    overflow: hidden;
    background: ${tokens.color.bg.surface.default};
    ${p => p.$image && BGImageCenter(p.$image, 'cover')}
`;

export const body = styled.div`
    ${dFlex};
    flex-direction: column;
    align-items: center;
    gap: var(--space-lg);
    padding: var(--space-xl) var(--space-md) var(--space-md);
    background: ${tokens.color.bg.base};
`;

export const name = styled.p`
    margin: 0;
    width: 100%;
    text-align: center;
    font-size: ${tokens.typography.fontSize.body};
    font-weight: ${tokens.typography.fontWeight.regular};
    line-height: 1.4;
    color: ${tokens.color.text.default};
    ${ellipsis};
`;

export const footerRow = styled.div`
    ${dFlex};
    align-items: center;
    justify-content: flex-end;
    width: 100%;
`;

export const whatsAppIcon = styled.div`
    width: 16px;
    height: 16px;
    flex-shrink: 0;
    ${BGImageCenter(whatsApp, 'contain')}
`;
